import type { MonsterDef } from '../../sim/registry';
import { registerStoryBosses } from '../bosses/story';
import { CRYPT_MONSTERS } from './crypt';
import { EMBERWILD_MONSTERS } from './emberwild';
import { FROSTHOLLOW_MONSTERS } from './frosthollow';
import { KEEP_MONSTERS } from './keep';
import { RIFT_MONSTERS } from './rift';
import { SUNSCAR_MONSTERS } from './sunscar';
import { TOMB_MONSTERS } from './tomb';

export { RIFT_ROSTER } from './rift';

/**
 * Every field, story-dungeon and rift monster (each id defined exactly once;
 * shared monsters such as `grubling`, `sand_golem`, `ice_wraith` or
 * `hollow_knight` live in the file of the zone that introduces them).
 * Endgame colossi / Deepvault / Warlord Siege bosses are registered separately.
 */
export const ALL_MONSTERS: MonsterDef[] = [
  ...EMBERWILD_MONSTERS,
  ...CRYPT_MONSTERS,
  ...SUNSCAR_MONSTERS,
  ...TOMB_MONSTERS,
  ...FROSTHOLLOW_MONSTERS,
  ...KEEP_MONSTERS,
  ...RIFT_MONSTERS,
];

/** Registers the BossScripts of every `brain: 'boss'` monster in ALL_MONSTERS. */
export function registerAllBossScripts(): void {
  registerStoryBosses();
}
